

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface FavCaseSheetParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface FavCaseSheet {
    id?: any;
    regId:any;
    visitId:any;
    favName:string;
    consultant:any;
    tenantId: any;
    branchId: any;
    
    parameters?: FavCaseSheetParameter[];
    links?: any;
}


export abstract class FavCaseSheetData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<FavCaseSheet[]>;
    abstract create(url: string, data: FavCaseSheet): Observable<FavCaseSheet[]>;
    abstract update(url: string, data: FavCaseSheet): Observable<FavCaseSheet>;
    abstract delete(url: string): Observable<any>;
}
